import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import CustomizedTextField from "../../Custom/CustomizedTextField";
import CustomizedComboBox from "../../Custom/CustomizedComboBox";
import { Controller } from "react-hook-form";
import CustomizedNumberTextField from "../../Custom/CustomizedNumberTextField";

export default function Purchase({
  control,
  errors,
  viewOnly,
  isInventoryPage,
}) {
  const { t } = useTranslation();

  const purchaseVatTypeOption = [
    { id: 0, value: "NO_VAT", label: "ไม่มี" },
    { id: 1, value: "VAT_0", label: "0 %" },
    { id: 2, value: "VAT_7", label: "7 %" },
  ];

  return (
    <Box>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
          <CustomizedNumberTextField
            control={control}
            name={"purchase_standard_price"}
            testId="item-purchase-price-text-field"
            label={t("inventory.items.purchasePrice")}
            error={Boolean(errors.purchase_standard_price)}
            helperText={errors.purchase_standard_price?.message}
            disabled={!isInventoryPage || viewOnly}
            textAlign="left"
            decimalScale={4}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Controller
            control={control}
            error={errors}
            name={"purchase_minimum_qty"}
            render={({ field }) => (
              <CustomizedTextField
                {...field}
                testId="item-purchase-minimum-qty-text-field"
                type="number"
                label={t("inventory.items.minimumOrder")}
                error={Boolean(errors.purchase_minimum_qty)}
                helperText={errors.purchase_minimum_qty?.message}
                disabled={!isInventoryPage || viewOnly}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <Controller
            control={control}
            error={errors}
            name={"purchase_vat_type"}
            render={({ field }) => (
              <CustomizedComboBox
                {...field}
                testId="item-purchase-vat-text-field"
                label={t("inventory.items.purchaseVatType")}
                options={purchaseVatTypeOption}
                onChange={(_, newValue) => {
                  field.onChange(newValue ? newValue.label : "");
                }}
                error={Boolean(errors.purchase_vat_type)}
                helperText={errors.purchase_vat_type?.message}
                disabled={!isInventoryPage || viewOnly}
              />
            )}
          />
        </Grid>
      </Grid>
      {/* <Typography fontWeight="bold" my={2} ml={1}>
        {t("inventory.items.accounting")}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Controller
            control={control}
            error={errors}
            name={"purchase_account"}
            render={({ field }) => (
              <CustomizedComboBox
                {...field}
                label={t("inventory.items.purchaseAccount")}
                options={[]}
                disabled={true}
              />
            )}
          />
        </Grid>
      </Grid> */}
    </Box>
  );
}
